import { THeaderResponse } from '@monorepo/types';
import { THeaderActions } from './header.actions';
import { act } from '@ngrx/effects';

export const initialState: THeaderResponse = {
  language: [],
  navigationTabs: [],
  shifts: [],
  isLoading: true,
  activeTab: 'ANALYTICS',
  isMobileNavVisible: false,
};

export function headerReducer(state = initialState, action: THeaderActions): THeaderResponse {
  switch (action.type) {
    case 'INITIALIZE_HEADER': {
      const navigationTabs = action.payload.headerResponse.navigationTabs;
      const languages = action.payload.headerResponse.language;
      return { ...state, navigationTabs: navigationTabs, language: languages };
    }
    case 'INITIALIZE_SHIFT':
      return { ...state, shifts: [...action.payload] };
    case 'HEADER_LOADED':
      return { ...state, isLoading: false };
    case 'HEADER_TAB_CHANGE':
      return { ...state, activeTab: action.payload.activeTab };
    case 'TOGGLE_MOBILE_NAV':
      return { ...state, isMobileNavVisible: !state.isMobileNavVisible };
    default:
      return state;
  }
}
